import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import SEO from "./SEO";
import { getRouteSeo } from "./routeMetadata";

function isComponentOwnedSeoRoute(pathname = "") {
  return (
    pathname.startsWith("/novosti/") ||
    pathname === "/galerija" ||
    pathname === "/erasmus-konkursi"
  );
}

export default function RouteSeo() {
  const location = useLocation();
  const { i18n } = useTranslation();
  const pathname = location.pathname;

  if (isComponentOwnedSeoRoute(pathname)) {
    return null;
  }

  const meta = getRouteSeo(pathname, i18n.language);

  return (
    <SEO
      title={meta.title}
      description={meta.description}
      pathname={pathname}
      pageType={meta.pageType}
      image={meta.image}
      imageAlt={meta.imageAlt}
      imageType={meta.imageType}
      imageWidth={meta.imageWidth}
      imageHeight={meta.imageHeight}
      contentLanguage={meta.contentLanguage}
      openGraphLocale={meta.openGraphLocale}
      alternateOpenGraphLocale={meta.alternateOpenGraphLocale}
      section={meta.section}
      noindex={meta.noindex}
      article={meta.article}
      breadcrumbs={meta.breadcrumbs}
      courseTitle={meta.courseTitle}
      programName={meta.programName}
      studyLevel={meta.studyLevel}
    />
  );
}
